import React, { useState } from "react";

const AutoCompleteInput = ({
    label,
    value,
    cssClass,
    labelClass,
    onChange,
    options = [],
    optionKey = "key",      // e.g. code
    optionValue = "value",  // e.g. name
    onSelect,
    isrequired=false,
    onCreate
}) => {
    const [showList, setShowList] = useState(false);

    const search = (value || "").toLowerCase();

    // Search by both key and value
    const filtered = options.filter((item) => {
        const key = String(item[optionKey] || "").toLowerCase();
        const val = String(item[optionValue] || "").toLowerCase();

        return key.includes(search) || val.includes(search);
    });

    return (
        <div
    style={{
        position: "relative",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        verticalAlign: "top",
    }}
>
    {label && (
        <label
            htmlFor="search-input"
            style={{
                fontSize: "12px",
                fontWeight: 600,
                marginBottom: "4px",
                textTransform:"uppercase"
            }}
            className={`${labelClass}`}
        >
            {label}
        </label>
    )}

    <input
        id="search-input"
        type="text"
        autoComplete="off"
        value={value || ""}
        placeholder={label}
        className={`${cssClass} w-full`}
        onChange={(e) => {
            onChange(e.target.value);
            setShowList(true);
        }}
        required={isrequired}
        onFocus={() => setShowList(true)}
        onBlur={() => setTimeout(() => setShowList(false), 200)}
        style={{
            width: "100%",
            padding: "5px",
            border: "1px solid #ccc",
            borderRadius: "4px",
        }}
        
        
    />
 {showList && (value || "") && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ddd",
                        zIndex: 999,
                        maxHeight: "180px",
                        overflowY: "auto"
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: "8px",
                                    cursor: "pointer"
                                }}
                                onMouseDown={() => {
                                    onSelect?.(item);
                                    onChange(item[optionKey]);
                                    setShowList(false);
                                }}
                            >
                                {item[optionKey]}
                            </div>
                        ))
                    ) : (<div></div>
                        // <div
                        //     style={{
                        //         padding: "8px",
                        //         cursor: "pointer",
                        //         color: "blue"
                        //     }}
                        //     onMouseDown={() => {
                        //         onCreate?.(value);
                        //         setShowList(false);
                        //     }}
                        // >
                        //     ➕ Add "{value}"
                        // </div>
                    )}
                </div>
            )}
    {/* Dropdown here */}
</div>
    );
};

export default AutoCompleteInput;